import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
// import {
//   FaPinterestP,
//   FaFacebookF,
//   FaTwitter,
//   FaYoutube,
//   FaGithub
// } from 'react-icons/fa';
import "tachyons";

export default () => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            siteTitle: title
            mailChimpUrl
            pinterest
            facebook
            twitter
            youtube
            github
          }
        }
      }
    `}
    render={data => (
      <footer className="pa2 bg-dark-gray near-white pv5">
        <div className="w-100 mw9 center silver mb3">
          <div className="flex w-100 mw6 items-center justify-center justify-start-ns">
            <a
              href="/sitemap.xml"
              className="silver sans-serif f5 tracked pv1 db mh1"
            >
              SITEMAP
            </a>
            <span className="mh1">|</span>
            <Link
              to="/privacy"
              className="silver sans-serif f5 tracked pv1 db mh1"
            >
              PRIVACY
            </Link>
          </div>
        </div>
        <div className="w-100 mw9 silver center sans-serif f6">
          <p>Aalon Capital LLC (C) 2019</p>
        </div>
      </footer>
    )}
  />
);
